module.exports = __webpack_public_path__ + "static/media/idp-approved-identification.cef7fcc8.svg";